/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import { MotorCarrierInfoFragmentDoc } from './MotorCarrierInfoFragment'
export type IMotorCarrierUserInfoFragment = { __typename?: 'MotorCarrierUser' } & Pick<
  Types.IMotorCarrierUser,
  'id' | 'createdAt'
> & {
    motorCarrier: { __typename?: 'MotorCarrier' } & Pick<
      Types.IMotorCarrier,
      | 'id'
      | 'legalName'
      | 'mcNumber'
      | 'dotNumber'
      | 'teamMemberCount'
      | 'state'
      | 'endorsements'
      | 'excludedCommodities'
    > & {
        equipmentCapability?: Types.Maybe<
          { __typename?: 'MotorCarrierEquipmentCapability' } & Pick<
            Types.IMotorCarrierEquipmentCapability,
            | 'id'
            | 'isDryVanCapable'
            | 'isFlatbedCapable'
            | 'isReeferCapable'
            | 'powerUnitCount'
            | 'trailerCount'
          >
        >
        freightCapability?: Types.Maybe<
          { __typename?: 'MotorCarrierFreightCapability' } & Pick<
            Types.IMotorCarrierFreightCapability,
            'id' | 'isDrayageCapable' | 'isFtlCapable' | 'isIntermodalCapable' | 'isLtlCapable'
          >
        >
        dedicatedLaneRatePreference?: Types.Maybe<
          { __typename?: 'MotorCarrierDedicatedLaneRatePreference' } & Pick<
            Types.IMotorCarrierDedicatedLaneRatePreference,
            'id' | 'isInterestedInDedicatedLanes' | 'minimumRatePerMile'
          >
        >
        loadingCapability?: Types.Maybe<
          { __typename?: 'MotorCarrierLoadingCapability' } & Pick<
            Types.IMotorCarrierLoadingCapability,
            'id' | 'isHeavyLoadCapable' | 'isDropCapable' | 'isLiveCapable' | 'isPowerOnly'
          >
        >
        rateTypePreference?: Types.Maybe<
          { __typename?: 'MotorCarrierRateTypePreference' } & Pick<
            Types.IMotorCarrierRateTypePreference,
            'id' | 'allowsDayRate' | 'allowsAllIn' | 'hasLineHaulFuelSurcharge'
          >
        >
        certifications: Array<
          { __typename?: 'MotorCarrierCertification' } & Pick<
            Types.IMotorCarrierCertification,
            'id' | 'code' | 'issuingOrganization' | 'isVerified' | 'renewalDate'
          >
        >
        smartWayRegistration?: Types.Maybe<
          { __typename?: 'MotorCarrierSmartWayRegistration' } & Pick<
            Types.IMotorCarrierSmartWayRegistration,
            'id' | 'isRegistered' | 'renewalDate'
          >
        >
      }
  }

export const MotorCarrierUserInfoFragmentDoc = gql`
  fragment MotorCarrierUserInfo on MotorCarrierUser {
    id
    createdAt
    motorCarrier {
      ...MotorCarrierInfo
    }
  }
  ${MotorCarrierInfoFragmentDoc}
`
